var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',{attrs:{"title":"Manutenção","titleIcon":"fas fa-tools"}},[_c('form-manutencao',{attrs:{"paramId":_vm.id},on:{"onSubmitManutencao":_vm.afterSubmit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }